import React from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
  Button,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { HashLink } from "react-router-hash-link";

export const FREQUENTLY_ASKED_QUESTIONS_LIST = [
  {
    title: "How does Den Den Claw work?",
    text: (
      <Typography>
        Den Den Claw is a claw machine arcade inspired by Japanese game centers.
        You purchase tokens at the counter, play the machines, and keep anything
        you win!
        <br />
        <br />
        If you’re feeling lucky, you can also trade prizes in for points and work
        toward something bigger.
      </Typography>
    ),
  },
  {
    title: "What’s the difference between tokens and points?",
    text: (
      <>
        <Typography sx={{ mb: 1 }}>
          <strong>Tokens</strong> are used to play the machines.
        </Typography>
        <Typography>
          <strong>Points</strong> are earned by trading in prizes you win.
          Collect enough points and redeem them for higher-value rewards.
        </Typography>
      </>
    ),
  },
  {
    title: "How much does it cost to play?",
    text: (
      <Typography>
        Tokens are $1 each. We also offer discounted bundles:
        <br />
        <br />
        $20 → 22 tokens  
        <br />
        $50 → 70 tokens  
        <br />
        $80 → 125 tokens  
        <br />
        $135 → 235 tokens  
        <br />
        $200 → 400 tokens
      </Typography>
    ),
  },
  {
    title: "I’m bad at claw machines… will I still have fun?",
    text: (
      <Typography>
        Absolutely. Our staff is always happy to give tips and help you learn.
        We believe everyone should go
        home a winner. If you're having trouble just ask for help!
      </Typography>
    ),
  },
  {
    title: "Do you host birthdays or events?",
    text: (
      <>
        <Typography sx={{ mb: 2 }}>
          Yes! We love hosting birthdays, private bookings, community events, and special
          themed nights.
        </Typography>

        <Button
          component={HashLink}
          smooth
          to="/explore/events"
          variant="contained"
          size="small"
          sx={{ borderRadius: 999, textTransform: "none", fontWeight: 600 }}
        >
          View Event Info →
        </Button>
      </>
    ),
  },
  {
    title: "Do you have a photobooth?",
    text: (
      <>
        <Typography sx={{ mb: 2 }}>
          Yes! We have a Japanese-style photobooth with fun props and filters.
        </Typography>

        <Button
          component={HashLink}
          smooth
          to="/explore/photobooth"
          variant="outlined"
          size="small"
          sx={{ borderRadius: 999, textTransform: "none", fontWeight: 600 }}
        >
          Photobooth Details
        </Button>
      </>
    ),
  },
  {
    title: "Do you offer memberships?",
    text: (
      <>
        <Typography sx={{ mb: 2 }}>
          We offer memberships for regulars who want extra perks and savings.
        </Typography>

        <Button
          component={HashLink}
          smooth
          to="/explore/memberships"
          variant="outlined"
          size="small"
          sx={{ borderRadius: 999, textTransform: "none", fontWeight: 600 }}
        >
          Membership Info
        </Button>
      </>
    ),
  },
  {
    title: "Is there a leaderboard?",
    text: (
      <>
        <Typography sx={{ mb: 2 }}>
          Yes! Check out our leaderboard to see top players and achievements.
        </Typography>

        <Button
          component={HashLink}
          smooth
          to="/explore/leaderboard"
          variant="outlined"
          size="small"
          sx={{ borderRadius: 999, textTransform: "none", fontWeight: 600 }}
        >
          View Leaderboard
        </Button>
      </>
    ),
  },
  {
    title: "How do I join the Artist Alley?",
    text: (
      <>
        <Typography sx={{ mb: 2 }}>
          Our Artist Alley features local artists selling prints, merch, and
          handmade goods. We rotate artists regularly and love supporting the
          community.
        </Typography>

        <Button
          component={HashLink}
          smooth
          to="/explore/artist-alley"
          variant="outlined"
          size="small"
          sx={{ borderRadius: 999, textTransform: "none", fontWeight: 600 }}
        >
          Apply to Artist Alley →
        </Button>
      </>
    ),
  },
  {
  title: "Do you rent claw machines or equipment?",
  text: (
    <>
      <Typography sx={{ mb: 2 }}>
        Yes! We offer claw machine rentals for tradeshows, corporate events,
        private parties, and special occasions.
        We can build a custom package based on your needs — including prizes,
        on-site support, and setup.
      </Typography>

      <Button
        component={HashLink}
        smooth
        to="/explore/rentals"
        variant="outlined"
        size="small"
        sx={{ borderRadius: 999, textTransform: "none", fontWeight: 600 }}
      >
        Learn About Rentals →
      </Button>
    </>
  ),
},
{
  title: "Do you offer gift cards?",
  text: (
    <>
      <Typography sx={{ mb: 2 }}>
        Gift cards are coming soon! 🎁  
        We’re working on token-based gift cards that are perfect for birthdays,
        holidays, and last-minute gifts.
      </Typography>

      <Button
        component={HashLink}
        smooth
        to="/explore/gift-cards"
        variant="outlined"
        size="small"
        sx={{ borderRadius: 999, textTransform: "none", fontWeight: 600 }}
      >
        Gift Card Info →
      </Button>
    </>
  ),
},

  {
    title: "What does “Den Den” mean?",
   text: (
    <>
      <Typography sx={{ mb: 2 }}>
        “Den” comes from the Japanese character 電, meaning electricity — a nod to
        the bright, energetic arcade culture that inspired us.
      </Typography>

      <Typography>
        The name is doubled because the business was founded by
        two brothers.
      </Typography>
    </>
  ),
  },
];
const FAQAccordion = () => {
  return (
    <Box sx={{ maxWidth: 900, mx: "auto", mt: 4 }}>
      {FREQUENTLY_ASKED_QUESTIONS_LIST.map((item, index) => (
        <Accordion
          key={index}
          sx={{
            borderRadius: 2,
            mb: 1,
            "&:before": { display: "none" },
          }}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="subtitle1" fontWeight={600}>
              {item.title}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>{item.text}</AccordionDetails>
        </Accordion>
      ))}
    </Box>
  );
};

export default FAQAccordion;
